import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import CashFlowProfitDetailsContainer from "./profitDetails/CashFlowProfitDetailsContainer";
import { useTranslation } from "react-i18next";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";

const CashFlowProfitList = ({ profits, filterData }) => {
  const { t } = useTranslation("cashFlow");

  if (!profits) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (profits.length === 0) {
    return <Alert severity="warning">{t("profit.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="768"
        size="14"
        className="profit-list-table"
      >
        <StyledTableHead scroll="auto" col="4" className="profit-list-table__head">
          <div>
            {t("profit.table.service")}
          </div>
          <div>
            {t("profit.table.paymentSystem")}
          </div>
          <div>
            {t("profit.table.currency")}
          </div>
          <div>
            {t("profit.table.profit")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {profits && profits.map((value, key) => (
            <CashFlowProfitDetailsContainer key={key} filterData={filterData} service={value} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default CashFlowProfitList;